// Angular app module declaration - separated to avoid circular dependencies
declare var angular: any;

// Make frontendApp globally accessible
(window as any).frontendApp = angular.module('frontendApp',
  ['ui.mask',
    'ui.sortable',
    'ui.bootstrap',
    'ngAnimate',
    'ngSanitize',
    'ngRoute',
    'ngResource',
    'ngCookies',
    'colorpicker.module',
    'cfp.hotkeys',
    'toggle-switch',
    'com.2fdevs.videogular',
    'com.2fdevs.videogular.plugins.controls',
    'com.2fdevs.videogular.plugins.overlayplay',
    'com.2fdevs.videogular.plugins.poster',
    'com.2fdevs.videogular.plugins.buffering',
    'textAngular',
    'textAngularToolbarPlugin',
    'smart-table',
    'angular.filter',
    'agGrid',
    'jsonFormatter',
    'checklist-model',
    'ngclipboard',
    "ngStomp",
    "ngIntlTelInput"]);

// Also make it available as local variable for this module
let frontendApp = (window as any).frontendApp;

// Restore $http .success() and .error() removed in Angular 1.6.
// Returns the same promise so multiple handlers can be chained on one request.
frontendApp.config(['$provide', function($provide: any) {
  $provide.decorator('$http', ['$delegate', function($delegate: any) {
    function addShims(promise: any) {
      promise.success = function(fn: Function) {
        promise.then(function(response: any) {
          fn(response.data, response.status, response.headers, response.config, response.statusText);
        });
        return promise;
      };
      promise.error = function(fn: Function) {
        promise.then(null, function(response: any) {
          fn(response.data, response.status, response.headers, response.config, response.statusText);
        });
        return promise;
      };
      return promise;
    }

    const wrapped: any = function(config: any) {
      return addShims($delegate(config));
    };

    angular.extend(wrapped, $delegate);

    ['get', 'post', 'put', 'delete', 'patch', 'head', 'jsonp'].forEach((method: string) => {
      if ($delegate[method]) {
        wrapped[method] = function() {
          return addShims($delegate[method].apply($delegate, arguments));
        };
      }
    });

    return wrapped;
  }]);
}]);

// Polyfill intl-tel-input v6 autoFormat behaviour (removed in v12).
// Reformats on blur (not keyup) to avoid cursor disruption during fast typing.
frontendApp.run(function() {
  $(document).on('blur', 'input[ng-intl-tel-input]', function(this: HTMLInputElement) {
    const instance = ($(this) as any).data('plugin_intlTelInput');
    if (instance && (window as any).intlTelInputUtils) {
      const num: string = instance.getNumber();
      if (num) {
        instance.setNumber(num);
      }
    }
  });
});